// Tree/target-subsystem action-type string constants. Extracted from
// actionCreators so that module exports only action-creator FUNCTIONS — that lets
// `useActions` drop its `as unknown as ActionCreatorsMapObject` cast (bindActionCreators
// wants a clean map of functions). Imported by the tree thunks (actionCreators),
// the tree reducer (reducers/tree), and the action tests.
export const SELECT_NODE = 'SELECT_NODE';
export const DESELECT_NODE = 'DESELECT_NODE';
export const TOGGLE_NODE = 'TOGGLE_NODE';
export const SHOW_DISABLED_TARGETS = 'SHOW_DISABLED_TARGETS';
export const EDIT_NODE = 'EDIT_NODE';
export const SET_CUSTOM_PICTURE = 'SET_CUSTOM_PICTURE';
export const SET_TOGGLED = 'SET_TOGGLED';
export const REQUEST_TREE = 'REQUEST_TREE';
export const REQUEST_TARGET = 'REQUEST_TARGET';
export const REQUEST_TREE_ERROR = 'REQUEST_TREE_ERROR';
export const REQUEST_TARGET_ERROR = 'REQUEST_TARGET_ERROR';
export const RECEIVE_TREE_SUCCESS = 'RECEIVE_TREE_SUCCESS';
export const RECEIVE_TARGET_SUCCESS = 'RECEIVE_TARGET_SUCCESS';
export const PARSE_TARGETS = 'PARSE_TARGETS';
export const SAVE_TARGET = 'SAVE_TARGET';
export const SAVE_TARGET_SUCCESS = 'SAVE_TARGET_SUCCESS';
export const SAVE_TARGET_ERROR = 'SAVE_TARGET_ERROR';
export const FILTER_TREE = 'FILTER_TREE';
export const RESET_TREE = 'RESET_TREE';
export const REQUEST_DELETE_TARGET = 'REQUEST_DELETE_TARGET';
export const REQUEST_DELETE_TARGET_SUCCESS = 'REQUEST_DELETE_TARGET_SUCCESS';
export const REQUEST_DELETE_TARGET_ERROR = 'REQUEST_DELETE_TARGET_ERROR';
export const REQUEST_DELETE_TARGET_FEEDBACK = 'REQUEST_DELETE_TARGET_FEEDBACK';
export const REQUEST_DELETE_TARGET_FEEDBACK_SUCCESS = 'REQUEST_DELETE_TARGET_FEEDBACK_SUCCESS';
export const REQUEST_DELETE_TARGET_FEEDBACK_ERROR = 'REQUEST_DELETE_TARGET_FEEDBACK_ERROR';
